import { computed } from 'vue';
import { NotificationStatuses } from '@/models/notifications.interface';
import store from '@/store';

export default class NotificationStatusCode {
	private notificationStatusResetDelay = 3000;

	public className = computed((): string => {
		switch (this.notificationStatus.value) {
			case NotificationStatuses.SAVING_IN_PROGRESS:
			case NotificationStatuses.CREATION_IN_PROGRESS:
				return 'NotificationStatusInProgress';
			case NotificationStatuses.SAVING_SUCCESS:
			case NotificationStatuses.CREATION_SUCCESS:
				return 'NotificationStatusSuccess';
			case NotificationStatuses.SAVING_ERROR:
			case NotificationStatuses.CREATION_ERROR:
				return 'NotificationStatusError';
			default:
				return '';
		}
	});

	public icon = computed((): string => {
		switch (this.notificationStatus.value) {
			case NotificationStatuses.SAVING_IN_PROGRESS:
			case NotificationStatuses.CREATION_IN_PROGRESS:
				return 'lnr-sync';
			case NotificationStatuses.SAVING_SUCCESS:
			case NotificationStatuses.CREATION_SUCCESS:
				return 'lnr-checkmark-circle';
			case NotificationStatuses.SAVING_ERROR:
			case NotificationStatuses.CREATION_ERROR:
				return 'lnr-notification-circle';
			default:
				return '';
		}
	});

	public message = computed((): string => {
		switch (this.notificationStatus.value) {
			case NotificationStatuses.SAVING_IN_PROGRESS:
				return 'Saving changes...';
			case NotificationStatuses.CREATION_IN_PROGRESS:
				return 'Creating campaign...';
			case NotificationStatuses.SAVING_SUCCESS:
				return 'Changes successfully saved!';
			case NotificationStatuses.CREATION_SUCCESS:
				return 'Campaign successfully created!';
			case NotificationStatuses.SAVING_ERROR:
				return 'Changes could not be saved. Please try again!';
			case NotificationStatuses.CREATION_ERROR:
				return 'Campaign could not be created. Please try again!';
			default:
				return '';
		}
	});

	public notificationStatus = computed((): NotificationStatuses => {
		return store.getters.notificationStatus();
	});

	public resetFinalNotificationStatus(newStatus: NotificationStatuses): void {
		const finalNotificationStatuses = [
			NotificationStatuses.CREATION_SUCCESS,
			NotificationStatuses.SAVING_SUCCESS,
			NotificationStatuses.CREATION_ERROR,
			NotificationStatuses.SAVING_ERROR
		];
		if (!finalNotificationStatuses.includes(newStatus)) {
			return;
		}

		setTimeout(() => {
			store.mutations.setNotificationStatus(NotificationStatuses.INACTIVE);
		}, this.notificationStatusResetDelay);
	}
}
